import { createAction, props } from '@ngrx/store';

export const setFinanceData = createAction('[financeData] Set financeData', props<{ isFinance : Boolean }>());
export const clearFinanceData = createAction('[financeData] Clear financeData');